import { render, staticRenderFns } from "./wxsfc.vue?vue&type=template&id=b0bac164&scoped=true&"
import script from "./wxsfc.vue?vue&type=script&lang=js&"
export * from "./wxsfc.vue?vue&type=script&lang=js&"
import style0 from "./wxsfc.vue?vue&type=style&index=0&id=b0bac164&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bac164",
  null
  
)

export default component.exports